/**
 * Origens do DRE em um filtro só.
 *
 * A tela tinha dois filtros separados, Conta ML e Origem, mas toda venda tem
 * `conta` preenchida (inclusive e-commerce e balcão), então "Conta 1" sozinha
 * trazia receita que não era do Mercado Livre. Aqui a conta só é enviada junto
 * da origem Mercado Livre, que é o único lugar onde ela significa alguma coisa.
 */
export const DRE_ORIGENS = [
  { value: 'ml1', label: 'Mercado Livre 1', params: { origem: 'Mercado Livre', conta: '1' } },
  { value: 'ml2', label: 'Mercado Livre 2', params: { origem: 'Mercado Livre', conta: '2' } },
  { value: 'ml3', label: 'Mercado Livre 3', params: { origem: 'Mercado Livre', conta: '3' } },
  { value: 'ecommerce', label: 'E-commerce', params: { origem: 'ECOMMERCE' } },
  { value: 'taga', label: 'TAGA (Manual)', params: { origem: 'TAGA' } },
];

/** Parâmetros de API da opção escolhida. Vazio = todas as origens. */
export const paramsDaOrigem = (valor) => {
  const opcao = DRE_ORIGENS.find((o) => o.value === valor);
  return opcao ? { ...opcao.params } : {};
};
